import { MouseEvent, useState } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { Button, Menu, MenuItem, Tooltip } from '@mui/material';

import { useLojaStepContext } from 'pages/cadastro/loja/contexts';

/**
 * Retorna o ícone de status do step.
 */
function ConfigPedidoMenuIcon({ fgDirty, isButton = false }: { fgDirty: boolean; isButton?: boolean }) {
    if (!fgDirty) {
        return (
            <Tooltip title="Salvo">
                <CheckCircleIcon sx={{ mr: 1.5 }} fontSize="small" color={isButton ? 'inherit' : 'primary'} />
            </Tooltip>
        );
    }

    return (
        <Tooltip title="Não salvo">
            <ErrorIcon sx={{ mr: 1.5 }} fontSize="small" color={isButton ? 'inherit' : 'error'} />
        </Tooltip>
    );
}

export function LojaMenu() {
    const { activeStep, requestStepChange, stepList } = useLojaStepContext();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLButtonElement>): void => setAnchorEl(event.currentTarget);
    const handleClose = (): void => setAnchorEl(null);

    return (
        <>
            <Button
                variant="contained"
                onClick={handleClick}
                endIcon={<MenuRoundedIcon />}
                sx={{
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    fontSize: 14,
                    minWidth: 264,
                    justifyContent: 'flex-start',
                    pl: 1.5,
                    flex: { xs: 1, sm: 0 },
                }}
            >
                <ConfigPedidoMenuIcon fgDirty={activeStep.fgDirty} isButton />

                <span style={{ flex: 1, textAlign: 'start', fontSize: 14 }}>{activeStep.dsConfiguracaoPropriedadeGrupoExibicao}</span>
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            width: anchorEl?.getBoundingClientRect().width || 264,
                        },
                    },
                }}
            >
                {stepList.map((item) => {
                    const isSelected = activeStep.idConfiguracaoPropriedadeGrupoExibicao === item.idConfiguracaoPropriedadeGrupoExibicao;

                    return (
                        <MenuItem
                            key={item.idConfiguracaoPropriedadeGrupoExibicao}
                            selected={isSelected}
                            disabled={item.fgDisabled}
                            sx={{ pl: 1.5 }}
                            onClick={() => {
                                requestStepChange(item);

                                handleClose();
                            }}
                        >
                            <ConfigPedidoMenuIcon fgDirty={item.fgDirty} />

                            {item.dsConfiguracaoPropriedadeGrupoExibicao}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}
